import React from "react";
import { formatEyebrowNumber } from "../knowledge-base-hub/knowledge-filters";

// Table of contents — scrolls the article list to the chosen row.
const ChapterSidebar = ({ articles, onJump }) => (
  <nav className="rounded-2xl border border-border bg-surface p-3">
    <p className="px-2 pt-1 pb-2 font-mono text-[10px] uppercase tracking-[0.18em] text-text_muted">
      In this chapter
    </p>
    <ul className="space-y-0.5">
      {articles.map((a) => (
        <li key={a.id}>
          <button
            type="button"
            onClick={() => onJump(a.id)}
            className="w-full flex items-baseline gap-2.5 px-2 py-1.5 rounded-lg text-left text-[12.5px] text-text_secondary cursor-pointer"
          >
            <span className="font-mono text-[10px] text-text_muted">{formatEyebrowNumber(a.orderInChapter)}</span>
            <span className={`line-clamp-2 ${a.viewer_state?.has_viewed ? "" : "font-semibold text-text_primary"}`}>
              {a.title}
            </span>
          </button>
        </li>
      ))}
    </ul>
  </nav>
);

export default ChapterSidebar;
